import videojs from 'video.js';

const dom = videojs.dom || videojs;
const registerPlugin = videojs.registerPlugin || videojs.plugin;
const Component = videojs.getComponent('Component');

// valueActualTtl - время в секундах, в течении которого данные по онлайну пользователей считаются
// актуальными
const defaultOptions = {
  valueActualTtl: 60,
  checkPeriod: 10
}

class CurrentOnline extends Component {
  constructor(player, options) {
    super(player, options);
    this.options_ = videojs.mergeOptions(defaultOptions, options);
    this.hide();
    // Проверяем вермя последнего сообщения каждые checkPeriod секунд
    this.setInterval(() => this.checkUpdates(), this.options_.checkPeriod * 1000);
  }

  createEl() {
    let el = dom.createEl('div', {
      className: 'vjs-current-online'
    });

    let icon = dom.createEl('div', {
      className: 'vjs-current-online-icon'
    });

    this.counterEl = dom.createEl('div', {
      className: 'vjs-current-online-counter'
    });

    dom.appendContent(el, [icon, this.counterEl]);
    return el;
  }

  checkUpdates() {
    if (!this.lastUpdateTime) {
      return;
    }
    const currentTime = new Date();
    // Если между текущим временем и временем последнего обновления прошло мало времени, то считаем,
    // что текущие данные неактуальны
    if (this.isLive() && ((currentTime - this.lastUpdateTime) < this.options_.valueActualTtl * 1000)) {
      return;
    }
    this.hide();
  }

  updateOnlineValue(value) {
    if (!this.isLive()) {
      return;
    }

    this.lastUpdateTime = new Date();
    if (value === undefined || value === null) return;
    value = value * 1;
    if (!Number.isInteger(value) || value < 0) return;
    this.show();
    this.counterEl.innerText = value;
  }

  isLive() {
    const hls = this.player().hls_;
    const hlsLevel = hls && hls.levels && hls.levels[hls.currentLevel];
    const isLive = hlsLevel && hlsLevel.details && hlsLevel.details.live;
    return isLive;
  }
}

const currentOnline = function(options) {
  const player = this;
  player.ready(() => {
    let _options = Object.assign({}, options);
    _options.name = 'CurrentOnline';
    const currentOnline = new CurrentOnline(player, _options);
    const topPanel = player.getChild('TopPanel');
    if (topPanel) {
      topPanel.addChild(currentOnline);
    } else {
      player.addChild(currentOnline);
    }
    player.updateOnlineViewers = currentOnline.updateOnlineValue.bind(currentOnline);
  });
};

registerPlugin('currentOnline', currentOnline);
export default currentOnline;
